<template>
  <div class="solve_page page_style">
    <NavVue index="02"></NavVue>

    <div class="banner" :style="'background: url('+(schemeType == 'bank'?bankBg:hospitalBg)+') 0% 0% / contain;'">
      <div v-if="schemeType == 'bank'">
        <div class="fs36 colorFF title">银行行业解决方案</div>
        <div class="fs18 colorFF">利用人工智能分析技术为银行客户提供全流程解决方案。</div>
      </div>

      <div v-else>
        <div class="fs36 colorFF title">银行行业解决方案</div>
        <div class="fs18 colorFF">利用人工智能分析技术为银行客户提供全流程解决方案。</div>
      </div>
    </div>
    
    <div class="tabs_list">
      <div class="tabs_header">
        <div v-for="item in tabsList" :key="item.code" class='tabs_header_item fs14 color33' :class="activeName == item.code?'active_menu':''" @click="tabClick(item)">
          {{ item.name }}
        </div>
      </div>
      <div v-for="item in tabsList" :key="item.code" class="tabs_content" :style="item.code == activeName?'':'display: none'">
        <div class="introduce_item content_item">
          <div class="title_box">
            <div class="circle"></div>
            <div class="content_title fs28 color33">方案简介</div>
            <div class="circle"></div>
          </div>
          <div class="content_introduce">
            <img :src="require('@/assets/images/scheme/'+item.imgSrc)" alt="" draggable="false">
            <div class="item_content">
              <div class="fs24 color33">{{ item.title }}</div>
              <div class="content_desc fs16 color65">{{ item.desc }}</div>
            </div>
          </div>
        </div>

        <div class="pain_item content_item" v-if="item.isPain">
          <div class="title_box">
            <div class="circle"></div>
            <div class="content_title fs28 color33">解决痛点</div>
            <div class="circle"></div>
          </div>
          <div class="content_pain">
            <div class="pain_list">
              <div class="list_item" v-for="(Item, index) in item.painList" :key="index">
                <div class="fs18 color33 texc">{{ Item.name }}</div>
                <div class="fs14 color66">{{ Item.desc }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="structure_item content_item" v-if="item.isStructure">
          <div class="title_box">
            <div class="circle"></div>
            <div class="content_title fs28 color33">方案架构</div>
            <div class="circle"></div>
          </div>
          <div class="content_structure">
            <img :src="require('@/assets/images/scheme/'+item.structureBg)" alt="" draggable="false">
          </div>
        </div>

        <div class="goodness_item content_item" v-if="item.isGoodNess">
          <div class="title_box">
            <div class="circle"></div>
            <div class="content_title fs28 color33">方案优势</div>
            <div class="circle"></div>
          </div>

          <div class="content_goodness" v-if="item.code == 'xdxt'">
            <div class="list_item" v-for="(Item, index) in item.goodNessList" :key="index">
              <img :src="require('@/assets/images/scheme/'+Item.imgSrc)" alt="" draggable="false">
              <div class="fs24 color33 texc">{{ Item.name }}</div>
              <div class="fs14 color65">{{ Item.desc }}</div>
            </div>
          </div>
          <div class="content_goodness" v-else>
            <div class="list_item_else" v-for="(Item, index) in item.goodNessList" :key="index">
              <img :src="require('@/assets/images/scheme/'+Item.imgSrc)" alt="" draggable="false">
              <div class="text_box">
                <div class="fs24 color33">{{ Item.name }}</div>
                <div class="fs14 color65">{{ Item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <FooterVue></FooterVue>
  </div>
</template>

<script>
import FooterVue from "../components/Footer.vue";
import NavVue from "../components/Nav.vue";

export default {
  components: {
    NavVue,
    FooterVue,
  },
  data() {
    return {
      schemeType: '',
      bankBg: require('../assets/images/scheme/banner@2x.png'),
      hospitalBg: require('../assets/images/scheme/banner_jjfa_yy@2x.png'),
      activeName: '',
      tabsList: [],
    };
  },
  mounted() {
    // console.log(this.getRequest())
    // 获取地址传参
    this.schemeType = this.getRequest().type
    this.activeName = this.getRequest().tab
    if (this.schemeType == 'bank') {
      this.tabsList = this.configData.index.scheme.list.slice(0,8)
    } else {
      this.tabsList = this.configData.index.scheme.list.slice(-2)
    }
    // console.log(this.tabsList)
  },
  methods: {
    tabClick(val) {
      this.activeName = val.code
      this.$router.push({path: val.link})
    }
  }
};
</script>

<style lang="less" scoped>
.solve_page {
  width: 100%;
  background: #F6F7FA;
  .banner{
    width: 100%;
    height: 2.083333rem;
    box-sizing: border-box;
    padding: 0.703125rem 0px 0px 1.875rem;
    .title{
      margin-bottom: 0.104167rem;
    }
  }

  .tabs_list{
    width: 100%;
    .tabs_header{
      display: flex;
      height: 0.364583rem;
      justify-content: center;
      align-items: center;
      border-bottom: 2px solid #EBEEF5;

      .tabs_header_item{
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0px 0.130208rem;
        color: #303133;
        cursor: pointer;

        &:after{
          display: none;
          position: absolute;
          content: '';
          width: 100%;
          height: 3px;
          left: 0px;
          bottom: 0px;
          background-color: #3371FF;
        }
      }
      .active_menu{
        &:after{
          display: block;
        }
      }
    }

    .tabs_content{
      width: 100%;

      .title_box{
        display: flex;
        justify-content: center;
        align-items: center;
        .content_title{
          font-weight: bold;
          margin: 0px 0.03125rem;
        }
        .circle{
          width: 0.03125rem;
          height: 0.03125rem;
          border: 2px solid #3371FF;
          border-radius: 6px;
        }
      }

      .content_item{
        box-sizing: border-box;
        padding: 0.416667rem 1.354167rem;

        &:nth-child(2n-1){
          background-color: #fff;
        }
      }

      .introduce_item{
        .content_introduce{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 2.291667rem;
          box-sizing: border-box;
          padding: 0.260417rem;
          box-shadow: 0px 0.015625rem 0.15625rem 0px rgba(2,51,103,0.14);
          border-radius: 0.052083rem;
          margin-top: 0.208333rem;
          img{
            width: 2.708333rem;
            margin-right: 0.260417rem;
          }
          .item_content{
            height: 100%;
            box-sizing: border-box;
            padding-top: 0.15625rem;
            .content_desc{
              height: 1.15625rem;
              box-sizing: border-box;
              padding: 0.1875rem 0px;
              line-height: 0.15625rem;
              background: url('../assets/images/index/img_fa_yh@2x.png') no-repeat;
              background-size: contain;
              margin: 0.104167rem 0px 0.0625rem 0px;
            }
          }
        }
      }

      .pain_item{
        padding: 0.416667rem 1.302083rem 0.302083rem;
        .content_pain{
          position: relative;
          width: 100%;
          height: 3.28125rem;
          margin-top: 0.114583rem;
          background: url('../assets/images/scheme/img_fa_jjtd@2x.png') no-repeat;
          background-size: contain;
          .pain_list{
            position: absolute;
            top: 1.895833rem;
            left: 0.260417rem;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .list_item{
              width: 1.25rem;
              margin-right: 0.625rem;
              div:last-child{
                margin-top: 0.052083rem;
                line-height: 0.145833rem;
              }

              &:last-child{
                margin: 0;
              }
            }
          }
        }
      }

      .structure_item{
        .content_structure{
          width: 100%;
          margin-top: 0.208333rem;
          img{
            width: 100%;
          }
        }
      }
      
      .goodness_item{
        .content_goodness{
          display: flex;
          flex-wrap: wrap;
          margin-top: 0.208333rem;
          .list_item{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width: 2.322917rem;
            height: 1.807292rem;
            box-sizing: border-box;
            padding: 0.260417rem 0.208333rem;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            margin-right: 0.130208rem;

            img{
              width: 0.520833rem;
              margin-bottom: 0.104167rem;
            }

            & div:nth-of-type(2){
              width: 1.90625rem;
              line-height: 0.145833rem;
              margin-top: 0.052083rem;
            }

            &:last-child{
              margin: 0;
            }
          }

          .list_item_else{
            display: flex;
            width: calc((100% - 0.208333rem)/2);
            height: 1.197917rem;
            background-color: #fff;
            box-sizing: border-box;
            padding: 0.260417rem 0.260417rem 0px;
            border: 1px solid #EBEEF5;
            margin: 0px 0.208333rem 0.3125rem 0px;

            img{
              width: 0.3125rem;
              height: 0.3125rem;
              margin-right: 0.104167rem;
            }
            .text_box{
              flex: 1;
              div:first-child{
                margin-bottom: 0.052083rem;
              }
            }

            &:nth-child(2n){
              margin-right: 0px;
            }
            &:nth-last-child(-n+2){
              margin-bottom: 0px;
            }
          }
        }
      }
    }
  }
}
</style>